module.exports = __webpack_public_path__ + "static/img/4.ae4ce69f.png";